<script lang="ts">
  import { getModalStore } from '@skeletonlabs/skeleton';
  import { goto } from '$app/navigation';
  import { Modal } from '$lib/components/modal';
  import { Stepper } from '$lib/components/stepper';
  import { AppPath } from '$lib/features/app';
  import { getClientBff } from '$lib/features/bff';
  import type { CompanyDto, ListJobParamsDto, MeListEstimateDto } from '$lib/features/bff/sdk';
  import { MeListStepCreateJob, MeListStepConfirmation } from '$lib/features/me/list';

  const modalStore = getModalStore();
  const company: CompanyDto = $modalStore[0].meta.company;
  const taxIds = company.offices.map((o) => o.taxId);

  let jobParams: ListJobParamsDto;
  let estimate: MeListEstimateDto;
  let size = taxIds.length;

  /**
   * Calculates estimated job cost
   */
  async function updateListEstimate() {
    estimate = undefined;

    const bff = await getClientBff();

    estimate = await bff.me.createListEstimate({
      maxAge: jobParams.maxAge || 45,
      taxIds,
    });
  }

  /**
   * Creates a new list, populate it with tax ids and
   * triggers a job execution
   */
  async function createListJob() {
    const bff = await getClientBff();

    const list = await bff.me.createList({
      title: company.name.slice(0, 30),
      description: `Consulta dos estabelecimentos da empresa ${company.name}.`,
      items: taxIds,
    });

    await bff.me.createJobByListId(list.id, { params: jobParams });

    modalStore.close();
    await goto(AppPath.ME_LIST);
  }
</script>

<Modal width="max-w-2xl">
  <Stepper submitLabel="Exportar" actions={[() => updateListEstimate(), () => createListJob()]}>
    <MeListStepCreateJob bind:jobParams />
    <MeListStepConfirmation bind:estimate bind:size bind:jobParams />
  </Stepper>
</Modal>
